
<div class="dtf-olp" style="background-color: #E6E6E6;"> 
  <div class="container_dashboard">
    <div class="dtf-dashboard" style="padding-top: 41px; padding-bottom: 0px;">
      
      <div class="example-button-row">
        <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [value]="selectedState" (change)="onChangeButton($event)">
          <mat-button-toggle  [value]="toggleEnum.Option7" [class.selected]="selectedState === toggleEnum.Option7" style="background-color: #00566A !important; color: white !important;">Make a Payment</mat-button-toggle>
          <mat-button-toggle  [value]="toggleEnum.Option1" [class.selected]="selectedState === toggleEnum.Option1">Principal Payment</mat-button-toggle>
          <mat-button-toggle  [value]="toggleEnum.Option3" [class.selected]="selectedState === toggleEnum.Option3">Statement Payment</mat-button-toggle>
          <mat-button-toggle  [value]="toggleEnum.Option6" [class.selected]="selectedState === toggleEnum.Option6">Recurring Payment</mat-button-toggle>
          <mat-button-toggle  [value]="toggleEnum.Option4" [class.selected]="selectedState === toggleEnum.Option4">Manage Bank Profile</mat-button-toggle>
          <mat-button-toggle  [value]="toggleEnum.Option2" [class.selected]="selectedState === toggleEnum.Option2">Payment History</mat-button-toggle>
          <mat-button-toggle  [value]="toggleEnum.Option8" [class.selected]="selectedState === toggleEnum.Option8">Help</mat-button-toggle>
        </mat-button-toggle-group>
        </div>
    </div> 
  </div>

        <div class="container_dashboard">
          <div style="padding-bottom: 21px;">

              <div class="cardlike">
                <h1>{{ 'onlinepayment.header' | translate }}</h1>
              
                <br>
                <div style="font-size: large;">
                  <p> You may have upcoming <a href="{{this.baseRedirect}}/home/scheduledpayment"><span
                        style="font-weight: bold; color: #00566A;">Scheduled Payments</span></a>. Click here to view the details and
                    dates. &nbsp;
                    <!-- <span>
                      <button matIconButton disabled aria-label="Example icon button with an open in new tab icon"
                        style="background: transparent; border: none; box-shadow: none;">
                        <a href="{{this.baseRedirect}}/home/scheduledpayment"><mat-icon
                            style="color: #00566A; height: 21px;">open_in_new</mat-icon></a>
                      </button>
                    </span> -->
                  </p>
                </div>
              </div>
            
              <div class="container_dashboard">
                <div *ngIf="(!this.tableLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                  <!--Spinner on Login Load-->
                  <div class="demo-container">
                    <span>{{ 'Invoice.Loading' | translate }}</span>
                    <div class="progress-bar">
                      <div class="progress-bar-value"></div>
                    </div>
                  </div>
                  <br>
                </div>
                
                    <!-- Selections &  Search Filters -->
                    <div *ngIf="monthlypayment">
                      <div class="row" style="display: flex;">
                        <div class="col-lg-5">
                          <div class="card" style="width: 95%; padding-bottom: 23px;">
                            <h5 style="font-weight: bold;">Select Bank Account</h5>
                            <p>Step 1: Select your preferred payment profile</p>
                            <div class="row">
                              <div class="col-lg-7 col-md-7 col-sm-2 col-6">
                                <mat-form-field class="dropdown" appearance="outline">
                                  <mat-label>{{ 'onlinepayment.select1' | translate }}<span style="color: red;">*</span></mat-label>
                                  <mat-select [(ngModel)]="selected" (ngModelChange)="onChange()">
                                    <mat-option *ngFor="let opt of dropDownList" [value]="opt.id">
                                      {{opt.selection}}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-7">
                          <div class="card" style=" width: 95%;">
                            <h5 style="font-weight: bold;">Search By :</h5>
                            <div class="row">
                              <div class="col-lg-6 col-md-6 col-sm-2 col-6" id="account-number-filter">
                                <p class="filter">{{ 'onlinepayment.filter1monthly' |
                                  translate }}</p>
                                <div class="row">
                                  <div class="col">
                                    <mat-form-field appearance="outline" style="width: 100%;">
                                      <mat-label>{{ 'onlinepayment.filter1label' | translate }}</mat-label>
                                      <input  maxlength="13" matInput style="outline: none;" (keyup)="applyFilterAcc($event.target.value)" #input type="number">
                                      <img matSuffix class="example-form-img"
                                        src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
                                    </mat-form-field>
                                  </div>
                      
                                </div>
                              </div>
                              <div class="col-lg-6 col-md-6 col-sm-5 col-6" id="due-date-filter">
                                <p class="filter" >{{ 'onlinepayment.filter3' | translate
                                  }} </p>
                                <div class="row">
                                  <div class="col">
                                  <mat-form-field appearance="outline" style="width: 100%;">
                                    <mat-label>{{ 'onlinepayment.filter3label' | translate }}</mat-label>
                                  
                                    <input matInput [formControl]="dueDateControl" (dateChange)="applyFilterDate($event.target.value)"
                                      [matDatepicker]="datepicker">
                                  
                                    <mat-datepicker #datepicker>
                                      <mat-datepicker-actions>
                                        <button mat-button matDatepickerCancel>
                                          {{ 'LoginModal.Cancel' | translate }}
                                        </button>
                                        <button mat-raised-button color="primary" matDatepickerApply>
                                          {{ 'LoginModal.Apply' | translate }}
                                        </button>
                                      </mat-datepicker-actions>
                                    </mat-datepicker>
                                  
                                    <span matSuffix class="date-suffix-wrapper">
                                      <mat-datepicker-toggle [for]="datepicker"></mat-datepicker-toggle>
                                      <img class="example-form-img" src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
                                    </span>
                                  
                                    <!-- Error Message -->
                                    <mat-error *ngIf="dueDateControl.hasError('matDatepickerParse')">
                                      Invalid date format
                                    </mat-error>
                                  </mat-form-field>
                      
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> 

                  <!-- table of MonthlyPayment Step 1 -->
                   <br>
                  <div *ngIf="monthlypaymentstep1">
                    <div class="card" style="width: 97%;">
                          <p>Step 2: Just fill in your payment amount and the date you want to make the payment.</p>

                          <div *ngIf="showWarning" style="color: black; font-size: 15px; font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; margin-bottom: 1%;" class="warning-message">
                            {{ warningMessage }}
                          </div>

                          <div style="color: red;
                          font-size: 15px;
                          font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; margin-bottom: 1%;" *ngIf="invalid">
                              Please correct the following information.
                               <ul style="list-style-type: disc;">
                                  <li *ngIf="required" style="margin-left:30px;" class="paragrapSpace" >Please supply the required information. An * indicates a required field. </li>
                                  <li *ngIf="selectone" style="margin-left:30px;" class="paragrapSpace">Please select at lease one account or less than 26 accounts.</li>
                                  <li *ngIf="amount" style="margin-left:30px;" class="paragrapSpace" >The payment amount must be greater than zero and less than or equal to $2,000,000.00 </li> 
                              </ul> 
          
                          </div>
                          <mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8" matSort>
                              <!--US/EN Table loading-->
                              <ng-container matColumnDef="{{column.name}}"
                                  *ngFor="let column of initMonthlyPaymentColumns; last as isLast; first as isFirst;">
  
                                  <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef
                                      style=" justify-content: left;">
  
                                      <!-- <span *ngIf="isFirst" style="margin-left: -22px;">
                                          <mat-checkbox [disabled]="selection >= 26" (click)="calculateTotalAmount()" (change)="$event ? masterToggle() : null"
                                              [checked]="selection.hasValue() && isAllSelected()"
                                              [indeterminate]="selection.hasValue() && !isAllSelected()">
                                          </mat-checkbox>
                                      </span> -->
                                      <div *ngIf="isFirst" >
                                        
                                          <mat-checkbox   [ngClass]="{'white-border': !isChecked}" [disabled]="selection >= 50" (click)="calculateTotalAmount()" (change)="$event ? masterToggle() : null"
                                            [checked]="selection.hasValue() && isAllSelected()"
                                            [indeterminate]="selection.hasValue() && !isAllSelected()">
                                          </mat-checkbox>
                                                                        
                                      </div>
                                      <!-- Account Number -->
                                      <div *ngIf="column.dispFormat=='acct'">
                                        <div class="row"> {{column.display}} </div>
                                        <!-- <div class="row">
  
                                            <div style="display: inline-flex;">
                                                <input
                                                    style="outline: none; width: 70%; margin-top: 2%; margin-bottom: 5%; height: 20px;"
                                                    (keyup)="applyFilterAcc($event.target.value)" #input type="text">
                                                <mat-icon fontIcon="search"></mat-icon>
  
                                            </div>
                                        </div> -->
                                      </div>
                                      <!-- Current Amount Due -->
                                      <div *ngIf="column.dispFormat=='currentamountdue'">
                                        <div class="row"> {{column.display}} </div>
                                        <!-- <div class="row">
  
                                            <div style="display: inline-flex;">
                                                <input
                                                    style="outline: none; width: 70%; margin-top: 2%; margin-bottom: 5%;  height: 20px;"
                                                    (keyup)="applyFilterCurrentAmountDue($event.target.value)"
                                                    #input type="text">
                                                <mat-icon fontIcon="search">
                                                </mat-icon>
                                            </div>
  
                                        </div> -->
                                      </div>
                                      <!-- Monthly Payment -->
                                      <div *ngIf="column.dispFormat=='currency'">
                                          <div class="row"> {{column.display }} </div>
                                      </div>
                                      <!-- Payment Date -->
                                      <div *ngIf="column.dispFormat=='date1'">
                                          {{column.display}} <br> <span style="font-size: small;">MM/DD/YYYY</span> 
                                      </div>
                                      <!-- Current Due Date -->
                                      <div *ngIf="column.dispFormat=='date'">
                                              <div class="row"> {{column.display}} </div>
                                              <!-- <div class="row">
                                                  <div style="display: inline-flex;">
                                                      <input
                                                          style="outline: none; width: 70%; height: 20px; margin-top: 4%; margin-bottom: 5%; "
                                                          (keyup)="applyFilterDate($event.target.value)" #input
                                                          type="date" data-date-format="MM DD YYYY">
                                                        
                                                      <mat-icon fontIcon="search">
                                                      </mat-icon>
                                                  </div>
                                              </div> -->
                                      </div>
  
                                  </mat-header-cell>
                                  <mat-cell *matCellDef="let element" style="justify-content: left;">
  
                                      <span class="mobile-label">
                                          <div *ngIf="!isFrench && column.dispFormat !== ''"> {{column.display}} :</div>
                                          <div *ngIf="!isFrench && column.dispFormat==''"> {{column.display}} </div>
                                          <div *ngIf="isFrench"> {{column.displayFR}} :</div>
                                      </span>
                                       <!-- Account Number -->
                                       <div *ngIf="isFirst">
                                        <div class="class-test">
                                        <mat-checkbox [disabled]="selection.isSelected >= 50" (click)="$event.stopPropagation(); calculateTotalAmount();"
                                          (change)="$event ? selection.toggle(element) : null"
                                          [checked]="selection.isSelected(element)">
                                        </mat-checkbox>
                                        </div>
                                       </div>
                                      <div *ngIf="column.dispFormat=='acct'"  [ngClass]="{'highlight-row': isHighlighted(element[column.name])}" [ngStyle]="isHighlighted(element[column.name]) ? {'color': 'black', 'font-weight': 'bold'} : {}"> 
                                        {{element[column.name]}}
                                      </div>
                                      <!-- Monthly Payment -->
                                      <div *ngIf="column.dispFormat=='currency'"> 
                                          {{element[column.name] | currency:'USD':true:'1.2-2'}}
                                      </div>
                                      <!-- Current Amount Due -->
                                      <div *ngIf="column.dispFormat=='currentamountdue'">
                                          <mat-form-field appearance="outline" style="width: 70%; margin-top: 7%; height: 70px;  justify-content: center; margin-bottom: -5px;">
                                          $ <input matInput min="0" type="text"  (keypress)="positiveNumberOnly($event)" maxlength="12" style="width:97px;" [(ngModel)]='element[column.name]' id="currentamountdue"  (keypress)="restrictToTwoDecimals($event, element[column.name])" (focusout)="convertToDecimal(element)"  />
                                          </mat-form-field>
                                             <span *ngIf="selection.isSelected(element) &&(['0.00'].includes(element.totalAmountDue)||element.totalAmountDue>2000000)" alt="" style="width: 5px;margin-left:5px;">
                                              <img src="static/assets/img/dtf-assets/images/redesign/required_box.gif" style="width: 5px;margin-left:5px;">
                                       </span>
                                      </div>
                                      <!-- Payment Date -->
                                      <div *ngIf="column.dispFormat=='date1'">                                    
                                              <mat-form-field appearance="outline" style="width: 63%; margin-top: 7%; height: 70px;  justify-content: center; margin-bottom: -5px;">
                                                <input matInput [min]="minDate" [max]="maxDate[element.agreementNumber]" [(ngModel)]="currentDate[element.agreementNumber]"
                                                  [matDatepicker]="datepicker">
                                                <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                                                <mat-datepicker #datepicker>
                                                  <mat-datepicker-actions>
                                                    <button mat-button matDatepickerCancel>{{ 'LoginModal.Cancel' | translate }}</button>
                                                    <button mat-raised-button color="primary" matDatepickerApply>{{ 'LoginModal.Apply' | translate
                                                      }}</button>
                                                  </mat-datepicker-actions>
                                                </mat-datepicker>
                                              </mat-form-field>   
                                      </div>
                                      <!-- Current Due Date -->
                                      <div *ngIf="column.dispFormat=='date'"> 
                                          {{element[column.name] | date:'MM/dd/yyyy'}}
                                      </div>
                                  </mat-cell>
                              </ng-container>
  
                              <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                              <ng-container matColumnDef="MonthlyPaymentResponseList">
                                  <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                                      [attr.colspan]="displayedMonthlyPaymentColumns.length">
                                  </mat-cell>
                              </ng-container>
  
                              <mat-header-row *matHeaderRowDef="displayedMonthlyPaymentColumns"></mat-header-row>
                              <mat-row *matRowDef="let element; columns: displayedMonthlyPaymentColumns;"
                                  class="example-element-row"
                                  [class.example-expanded-row]="MonthlyPaymentResponseList === element"
                                  (click)="MonthlyPaymentResponseList = MonthlyPaymentResponseList === element ? null : element">
                              </mat-row>
                              <mat-row *matRowDef="let row; columns: ['MonthlyPaymentResponseList']"
                                  class="example-detail-row"></mat-row>
  
                              <!-- Row shown when there is no matching data. -->
                              <tr class="mat-row" *matNoDataRow>
                                  <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter
  
                                  </td>
                                  <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
                                  </td>
                              </tr>
  
                          </mat-table>
                          <mat-paginator [pageSizeOptions]="[5,10, 25, 100]"></mat-paginator>
                      </div>
                      <br>
                      <div class="total-amount-wrapper && tile" style="margin-right: 30px;">
                        <div>                
                          <mat-form-field appearance="outline" style="width: 100%;">
                            <mat-label>{{ 'onlinepayment.select2' | translate }}<span style="color: darkred;">*</span></mat-label>
                            <input matInput [value]="totalAmount | currency: USD:true:'1.2-2'" readonly/>                                          
                          </mat-form-field>
                        </div>

                        <button type="submit" class="mbfs-button submit-button" (click)="onSubmit()">
                          {{ 'onlinepayment.submit' | translate }}
                        </button>
                      </div>

                  </div>
                  <br>
                 

                  <div *ngIf="payoff">
                    <div class="card" style="width: 97%; ">
                      <p style="font-weight: bold; font-size: 15px;">{{ 'onlinepayment.MonthlyPayment' | translate }}
                      </p>
                      <div style="color: red;
                      font-size: 15px;
                      font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; margin-bottom: 1%;" *ngIf="error">
                          Please correct the following information.
                           <ul>
                              <li *ngIf="required" style="margin-left:30px;" class="paragrapSpace" >Please supply the required information. An * indicates a required field. </li>
                              <li *ngIf="amount" style="margin-left:30px;" class="paragrapSpace" >The payment amount must be greater than zero and less than or equal to $2,000,000.00 </li> 
                          </ul> 
                      </div>
                      <mat-table [dataSource]="multipayoffdataSource" multiTemplateDataRows class="mat-elevation-z8" matSort>
                        <!--US/EN Table loading-->
                        <ng-container matColumnDef="{{column.name}}"
                          *ngFor="let column of initPayoffColumns2; last as isLast; first as isFirst;">
                    
                          <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef style=" justify-content: left;">                 
                            <div> {{column.display}}</div>
                          </mat-header-cell>
                          <mat-cell *matCellDef="let element" style="justify-content: left;">
                    
                            <span class="mobile-label">
                              <div *ngIf="!isFrench"> {{column.display}} :</div>
                              <div *ngIf="isFrench"> {{column.displayFR}} :</div>
                            </span>
  
                            <div *ngIf="column.dispFormat==''" style="margin-left: 30px;"> <!--Formats String Columns-->
                              {{element[column.name]}}
                            </div>
  
                            <div *ngIf="column.dispFormat=='amt'" style="margin-left: 40px;"> <!--Formats String Columns-->
                              {{element[column.name] | currency:'USD':true:'1.2-2'}}
                            </div>
  
                            <div *ngIf="column.dispFormat=='date'" style="margin-left: 25px;"> <!--Formats String Columns-->
                              {{ currentDates | date:'MM/dd/yyyy' }}
                            </div>
  
                          </mat-cell>
                        </ng-container>
                    
                        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                        <ng-container matColumnDef="payoffResponseBeanList">
                          <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                            [attr.colspan]="displayedPayoffColumns2.length">
                          </mat-cell>
                        </ng-container>
                    
                        <mat-header-row *matHeaderRowDef="displayedPayoffColumns2"></mat-header-row>
                        <mat-row *matRowDef="let element; columns: displayedPayoffColumns2;" class="example-element-row"
                          [class.example-expanded-row]="payoffResponseBeanList === element"
                          (click)="payoffResponseBeanList = payoffResponseBeanList === element ? null : element">
                        </mat-row>
                        <mat-row *matRowDef="let row; columns: ['payoffResponseBeanList']" class="example-detail-row"></mat-row>
                    
                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                          <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter
                    
                          </td>
                          <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
                          </td>
                        </tr>
                    
                      </mat-table>
                      <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
                    </div>
                    <br>
                    <div>
                      <div class="card"
                      style=" width: 97%;">
                      <h5 style="font-weight: bold;">Select Bank Account</h5>
                      <p>Select your preferred payment profile</p>
                      <div class="row">
                       
                          <div class="col-lg-3 col-md-3 col-sm-2 col-6">
                            <mat-form-field appearance="outline" style="width: 100%;">
                              <mat-label>{{ 'onlinepayment.select1' | translate }}<span style="color: red;">*</span></mat-label>
                              <mat-select [(ngModel)]="selected" (ngModelChange)="onChange()">
                                <mat-option *ngFor="let opt of dropDownList" [value]="opt.id">
                                  {{opt.selection}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-2 col-6">
                              <mat-form-field appearance="outline" style="width: 110%;">
                                  <mat-label>{{ 'onlinepayment.select2' | translate }}<span style="color: darkred;">*</span></mat-label>
                                   <input matInput  [value]="amountPayoff | currency: USD" readonly/>                                          
                              </mat-form-field>
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-2 col-6"></div>
                          <div class="col-lg-3 col-md-3 col-sm-2 col-6">
                              <button type="submit" class="mbfs-button" style="margin-top: 4%;" (click)="onSubmitPayoff()">{{ 'onlinepayment.submit'
                                  | translate }}</button>
                          </div>
                      </div>
                  </div>
                    </div>
                  </div>
  
                  <div *ngIf="payoffstep2">
                    <div class="card">
                    <div style="display: flex;">
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline" style="width: 110%;">
                            <mat-label>Selected Bank Profile<span style="color: red;">*</span></mat-label>
                             <input matInput  [value]="getSelectedBankName()" readonly/>                                          
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline" style="width: 110%;">
                            <mat-label>{{ 'onlinepayment.select2' | translate }}<span style="color: red;">*</span></mat-label>
                             <input matInput  [value]="amountPayoff | currency: USD" readonly/>                                          
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                    <mat-table [dataSource]="multipayoffdataSource" multiTemplateDataRows class="mat-elevation-z8" matSort>
                      <!--US/EN Table loading-->
                      <ng-container matColumnDef="{{column.name}}"
                        *ngFor="let column of initPayoffColumns2; last as isLast; first as isFirst;">
                  
                        <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef style=" justify-content: left;">                 
                          <div> {{column.display}}</div>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" style="justify-content: left;">
                  
                          <span class="mobile-label">
                            <div *ngIf="!isFrench"> {{column.display}} :</div>
                            <div *ngIf="isFrench"> {{column.displayFR}} :</div>
                          </span>
  
                          <div *ngIf="column.dispFormat==''" style="margin-left: 30px;"> <!--Formats String Columns-->
                            {{element[column.name]}}
                          </div>
  
                          <div *ngIf="column.dispFormat=='amt'" style="margin-left: 40px;"> <!--Formats String Columns-->
                            {{element[column.name] | currency:'USD':true:'1.2-2'}}
                          </div>
  
                          <div *ngIf="column.dispFormat=='date'" style="margin-left: 25px;"> <!--Formats String Columns-->
                            {{  this.currentDates | date:'MM/dd/yyyy' }}
                          </div>
  
                        </mat-cell>
                      </ng-container>
                  
                      <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                      <ng-container matColumnDef="payoffResponseBeanList">
                        <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                          [attr.colspan]="displayedPayoffColumns2.length">
                        </mat-cell>
                      </ng-container>
                  
                      <mat-header-row *matHeaderRowDef="displayedPayoffColumns2"></mat-header-row>
                      <mat-row *matRowDef="let element; columns: displayedPayoffColumns2;" class="example-element-row"
                        [class.example-expanded-row]="payoffResponseBeanList === element"
                        (click)="payoffResponseBeanList = payoffResponseBeanList === element ? null : element">
                      </mat-row>
                      <mat-row *matRowDef="let row; columns: ['payoffResponseBeanList']" class="example-detail-row"></mat-row>
                  
                      <!-- Row shown when there is no matching data. -->
                      <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter
                  
                        </td>
                        <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
                        </td>
                      </tr>
                  
                    </mat-table>
                   
                    </div>
                        <br>
                        <p> Please review the following Authorization Statement before submitting your payment for processing.</p>
                        <br>
                        <div class="card">
                      <p style="padding: 10px; text-align:justify ;">
                        {{ 'onlinepayment.auth' | translate }}
                      <br><br>
                       <span style="font-weight: bold;">Notice:</span> The entry of a future dated payment transaction shall not be deemed or construed as acceptance by DTFS of a promise to pay in the future, a deferred payment offer or an amendment to the payment due dates in my lease, retail installment contract or promissory note and security agreement.	
                      </p>
                    </div>
                      <br>
                      <mat-checkbox class="example-margin" [(ngModel)]="isChecked">
                        <label style="margin: 0px;">I have read and accept the terms of the above Authorization Statement.</label>   
                      </mat-checkbox> 
                      <br>
                      <br>
                      <button class="mbfs-button" [disabled]="!isChecked || !this.tableLoaded" (click)="PayoffAuthorize()">Authorize</button>
                      <button class="mbfs-button" (click)="back2step1()">Cancel</button>
                  </div>
  
                  <div *ngIf="payoffstep3">
                    <div class="card">
                      <p> Thank you for using the Online Payment Service. Please click "Print" to print your authorization(s) and retain them for your records.</p>
                      <br>
                      <div style="display: flex;">
                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline" style="width: 110%;">
                              <mat-label>Selected Bank Profile<span style="color: red;">*</span></mat-label>
                               <input matInput  [value]="getSelectedBankName()" readonly/>                                          
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline" style="width: 110%;">
                              <mat-label>{{ 'onlinepayment.select2' | translate }}<span style="color: red;">*</span></mat-label>
                               <input matInput  [value]="amountPayoff | currency: USD" readonly/>                                          
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="failureError" style="color: red;
                          font-size: 15px;
                          font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; margin-bottom: 1%;">
                          We are currently experiencing technical difficulties, Please try again later.
                      </div>
                      <br>
                      <mat-table [dataSource]="multipayoffdataSource" multiTemplateDataRows class="mat-elevation-z8" matSort>
                        <!--US/EN Table loading-->
                        <ng-container matColumnDef="{{column.name}}"
                          *ngFor="let column of initPayoffColumns; last as isLast; first as isFirst;">
                    
                          <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef style=" justify-content: left;">                 
                            <div> {{column.display}}</div>
                          </mat-header-cell>
                          <mat-cell *matCellDef="let element" style="justify-content: left; pointer-events: none;">
                    
                            <span class="mobile-label">
                              <div *ngIf="!isFrench"> {{column.display}} :</div>
                              <div *ngIf="isFrench"> {{column.displayFR}} :</div>
                            </span>
    
                            <div *ngIf="column.dispFormat==''" style="margin-left: 30px;"> <!--Formats String Columns-->
                              {{element[column.name]}}
                            </div>
    
                            <div *ngIf="column.dispFormat=='amt'" style="margin-left: 40px;"> <!--Formats String Columns-->
                              {{element[column.name] | currency:'USD':true:'1.2-2'}}
                            </div>
    
                            <div *ngIf="column.dispFormat=='date'" style="margin-left: 25px;"> <!--Formats String Columns-->
                              {{ this.paymentDate | date:'MM/dd/yyyy' }}
                            </div>
                             <div *ngIf="column.dispFormat=='transaction'" style="color: blue;"> <!--Formats String Columns-->
                                {{this.reference}}
                              </div>
                               <div *ngIf="column.dispFormat=='status'"> <!--Formats String Columns-->
                                {{this.status}}
                              </div>
    
                          </mat-cell>
                        </ng-container>
                    
                        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                        <ng-container matColumnDef="payoffResponseBeanList">
                          <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                            [attr.colspan]="displayedPayoffColumns.length">
                          </mat-cell>
                        </ng-container>
                    
                        <mat-header-row *matHeaderRowDef="displayedPayoffColumns"></mat-header-row>
                        <mat-row *matRowDef="let element; columns: displayedPayoffColumns;" class="example-element-row"
                          [class.example-expanded-row]="payoffResponseBeanList === element"
                          (click)="payoffResponseBeanList = payoffResponseBeanList === element ? null : element">
                        </mat-row>
                        <mat-row *matRowDef="let row; columns: ['payoffResponseBeanList']" class="example-detail-row"></mat-row>
                    
                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                          <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter
                    
                          </td>
                          <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
                          </td>
                        </tr>
                    
                      </mat-table>
                      
                    </div>
                      <br>
                      <button class="mbfs-button" (click)="DownloadPdfPayoff()">Print</button>
                      <button class="mbfs-button" (click)="BacktoDashBoard()">Done</button>
  
                
  
                  </div>
                
                  <!-- MonthlyPayment Step 2 on click of Submit Payment-->
                  <div *ngIf="monthlypaymentstep2">
                    <div class="card">
                    <div style="display: flex;">
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline" >
                            <mat-label>Selected Bank Profile<span style="color: red;">*</span></mat-label>
                             <input matInput  [value]="getSelectedBankName()" readonly/>                                          
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline" >
                            <mat-label>{{ 'onlinepayment.select2' | translate }}<span style="color: red;">*</span></mat-label>
                             <input matInput  [value]="totalAmount | currency: USD:true:'1.2-2'" readonly/>                                          
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                      <mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8" matSort>
                          <!--US/EN Table loading-->
                          <ng-container matColumnDef="{{column.name}}"
                            *ngFor="let column of initMonthlyPaymentColumnsStep2; last as isLast; first as isFirst;">
                            <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef>
                              <div> {{column.display}}</div>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element">
                              <span class="mobile-label">
                                <div> {{column.display}} :</div>
                              </span>
                              <div *ngIf="column.dispFormat=='currency'"> <!--Formats Currency Columns-->
                                {{element[column.name] | currency:'USD':true:'1.2-2'}}
                              </div>
                              <div *ngIf="column.dispFormat=='currentamountdue'"> <!--Formats Contract String Columns-->
                                 {{element[column.name] | currency:'USD':true:'1.2-2'}}
                              </div>
                              <div *ngIf="column.dispFormat=='acct'"> <!--Formats String Columns-->
                                {{element[column.name]}}
                              </div>
                              <div *ngIf="column.dispFormat=='date'"> <!--Formats date Columns-->
                                {{element[column.name] | date:'MM/dd/yyyy'}}
                              </div>
                              <div *ngIf="column.dispFormat=='date1'"> <!--Formats date Columns-->
                                  {{element[column.name]  | date:'MM/dd/yyyy'}}
                                </div>
                            </mat-cell>
                          </ng-container>
            
                          <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                          <ng-container matColumnDef="selectedMonthlyResponseList">
                            <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                              [attr.colspan]="displayedMonthlyPaymentColumnsStep2.length">
                            </mat-cell>
                          </ng-container>
            
                          <mat-header-row *matHeaderRowDef="displayedMonthlyPaymentColumnsStep2"></mat-header-row>
                          <mat-row *matRowDef="let element; columns: displayedMonthlyPaymentColumnsStep2;" class="example-element-row"
                            [class.example-expanded-row]="selectedMonthlyResponseList === element"
                            (click)="selectedMonthlyResponseList = selectedMonthlyResponseList === element ? null : element">
                          </mat-row>
                          <mat-row *matRowDef="let row; columns: ['selectedMonthlyResponseList']" class="example-detail-row"></mat-row>
            
                          <!-- Row shown when there is no matching data. -->
                          <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter </td>
                            <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
                             </td>
                          </tr>
            
                        </mat-table>
                        <br>
                      </div>
                        <br>
                        <p style="margin-left: 10px; font-weight: bold;"> Please review the following Authorization Statement before submitting your payment for processing.</p>
                        <div class="card">
                      <p style="padding: 10px; text-align:justify ;">
                        {{ 'onlinepayment.auth' | translate }}
                      <br><br>
                       <span style="font-weight: bold;">Notice:</span> The entry of a future dated payment transaction shall not be deemed or construed as acceptance by DTFS of a promise to pay in the future, a deferred payment offer or an amendment to the payment due dates in my lease, retail installment contract or promissory note and security agreement.	
                      </p>
                    </div>
                      <br>
                      <mat-checkbox class="example-margin" [(ngModel)]="isChecked">
                        <label style="margin: 0px;">I have read and accept the terms of the above Authorization Statement.</label>   
                      </mat-checkbox> 
                      <br>
                      <br>
                      <div style="display:flex;flex-direction: row;gap:10px" >
                      <div *ngIf="agentview ==='true'">
                         <button class="mbfs-button" disabled>Authorize</button>
                      </div>
                       <div *ngIf="agentview !='true'">
                         <button class="mbfs-button" [disabled]="!isChecked || !this.tableLoaded" (click)="MonthlyPaymentAuthorize()">Authorize</button>
                       </div>
                     
                      <button class="mbfs-button" (click)="back2step1()">Cancel</button>
                      </div>
                  </div>
                  <!-- MonthlyPayment Step 3 on click of Authorize-->
                  <div *ngIf="monthlypaymentstep3">
                    <div class="card">
                      <p style="font-weight: bold;"> Thank you for using the Online Payment Service. Please click "Print" to print your authorization(s) and retain them for your records.</p>
                      <div style="display: flex;">
                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline" style="width: 110%;">
                              <mat-label>Selected Bank Profile<span style="color: red;">*</span></mat-label>
                               <input matInput  [value]="getSelectedBankName()" readonly/>                                          
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline" style="width: 110%;">
                              <mat-label>{{ 'onlinepayment.select2' | translate }}<span style="color: red;">*</span></mat-label>
                               <input matInput  [value]="totalAmount | currency:'USD':'symbol':'1.2-2'" readonly/>                                          
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    
                      <div *ngIf="failureError" style="color: red;
                          font-size: 15px;
                          font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; margin-bottom: 1%;">
                          We are currently experiencing technical difficulties, Please try again later.
                      </div>
                      <br>
                      <mat-table [dataSource]="paymentdataSource" multiTemplateDataRows class="mat-elevation-z8" matSort style="pointer-events: none;">
                          <!--US/EN Table loading-->
                          <ng-container matColumnDef="{{column.name}}"
                            *ngFor="let column of initColumns; last as isLast; first as isFirst;">
                            <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef style="justify-content: center; pointer-events: none;">
                              <div> {{column.display}}</div>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" style="justify-content: center; pointer-events: none;">
                              <span class="mobile-label">
                                <div> {{column.display}} :</div>
                              </span>
                              <div *ngIf="column.dispFormat=='currentamountdue'"> <!--Formats Contract String Columns-->
                                 {{element[column.name] | currency:'USD':true:'1.2-2'}}
                              </div>
                               <div *ngIf="column.dispFormat=='acct'"> <!--Formats Contract String Columns-->
                                 {{element[column.name]}}
                              </div>
                              <div *ngIf="column.dispFormat=='transaction'" style="color: blue;"> <!--Formats String Columns-->
                                 {{element[column.name]}}
                              </div>
                               <div *ngIf="column.dispFormat=='status'"> <!--Formats String Columns-->
                                {{element[column.name]}}
                              </div>
                              <div *ngIf="column.dispFormat=='date1'"> <!--Formats date Columns-->
                                {{element[column.name]  | date:'MM/dd/yyyy'}}
                                </div>
                            </mat-cell>
                          </ng-container>
            
                          <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                          <ng-container matColumnDef="paymentPostedList">
                            <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                              [attr.colspan]="displayedColumns.length">
                            </mat-cell>
                          </ng-container>
            
                          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                          <mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"
                            [class.example-expanded-row]="paymentPostedList === element"
                            (click)="paymentPostedList = paymentPostedList === element ? null : element">
                          </mat-row>
                          <mat-row *matRowDef="let row; columns: ['paymentPostedList']" class="example-detail-row"></mat-row>
            
                          <!-- Row shown when there is no matching data. -->
                          <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter </td>
                            <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
                             </td>
                          </tr>
            
                      </mat-table>
                      <br>
                    </div>
                      <br>
                      <button class="mbfs-button" (click)="DownloadPdf()">Print</button>
                      <button class="mbfs-button" (click)="BacktoDashBoard()">Done</button>
  
                  </div>
  
              </div>
          </div>
      </div> 
</div>